<button
  class="filters-btn btn btn-sm btn-secondary px-2 py-1 lh-sm fs-5"
  [class.facet-navigation__button]="hasTrigger$ | async"
  (click)="launch()"
  #trigger>
  {{ 'rrs.productFacetNavigation.filter' | cxTranslate }}
</button>
